import PropTypes from 'prop-types';
import { Error, Typography } from '@figure/frontlib-gui';
import { LI, UL } from 'shared/components/List';
import { Instruction, InstructionButtonGroup } from './';

const AssetInstruction = ({ handleBack, handleClick, serverError }) => (
  <Instruction space="1.6rem">
    <Typography.BodyBold semanticElement="h2">What you’ll need:</Typography.BodyBold>

    <UL resetMargin={false}>
      <LI>Online account(s) for your financial institution</LI>
      <LI>Account login credentials</LI>
      <LI>Eligible supporting accounts, such as Retirement, 401k, IRA, Roth, Savings, Brokerage, Money Market, and CD accounts</LI>
    </UL>

    <Error display="block">{serverError}</Error>

    <InstructionButtonGroup buttonText="Link assets" handleBack={handleBack} handleClick={handleClick} />
  </Instruction>
);

AssetInstruction.propTypes = {
  handleBack: PropTypes.func.isRequired,
  handleClick: PropTypes.func.isRequired,
  serverError: PropTypes.string.isRequired,
};

export default AssetInstruction;
